import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=37534b8e&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=37534b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37534b8e",
  null
  
)

export default component.exports